import {ReactNode, useState} from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function () {
  const {t} = useInferableTranslation();

  return (
    <>
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T40149')}</h1>
      </Header>
      <main className="content page_safe_driving">
        <section className="section">
          <div className="driving_accordion type_faq">
            <ul className="driving_accordion_list">
              <GuideItem
                title={t('T20149')}
                isInitOpen
              >
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20150')}</li>
                  <li className="section_bullet_item">{t('T20151')}</li>
                  <li className="section_bullet_item">{t('T20152')}</li>
                </ul>
                <div className="accordion_content_imgbox">
                  <div className="text_top">
                    <span className="text_guide01">
                      {t('T20275')}
                      <span className="blind">D-91</span>
                    </span>
                    <span className="text_guide02">
                      {t('T20276')}
                      <span className="blind">D-90, D-89 ... D-1, Today</span>
                    </span>
                  </div>
                  <div className="text_bottom">
                    <span className="text_guide03">
                      {t('T20275')}
                      <span className="blind">D-91, D-90</span>
                    </span>

                    <span className="text_guide04">
                      {t('T20277')}
                      <span className="blind">D-89 ... D-1, Today, D+1</span>
                    </span>
                  </div>
                  <ImageSelector
                    className="accordion_content_img"
                    alt="accordion_content_img"
                    kiaLightSrc={() => import('@di-shared/assets/img/safe_driving_score/score_distance_guide_light.png')}
                    kiaDarkSrc={() => import('@di-shared/assets/img/safe_driving_score/score_distance_guide.png')}
                    hyundaiLightSrc={() => import('@di-shared/assets/img/safe_driving_score/hyundai/score_distance_guide_light.png')}
                    hyundaiDarkSrc={() => import('@di-shared/assets/img/safe_driving_score/hyundai/score_distance_guide.png')}
                    genesisLightSrc={() => import('@di-shared/assets/img/safe_driving_score/genesis/score_distance_guide_light.png')}
                    genesisDarkSrc={() => import('@di-shared/assets/img/safe_driving_score/genesis/score_distance_guide.png')}
                  />
                </div>
              </GuideItem>
              <GuideItem title={t('T20153')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20154')}</li>
                  <li className="section_bullet_item">{t('T20155')}</li>
                </ul>
                <dl className="accordion_content_define">
                  <div className="define_item">
                    <dt className="define_term">{t('T10011')}</dt>
                    <dd className="define_detail">{t('T20156')}</dd>
                  </div>
                  <div className="define_item">
                    <dt className="define_term">{t('T10012')}</dt>
                    <dd className="define_detail">{t('T20157')}</dd>
                  </div>
                  <div className="define_item">
                    <dt className="define_term">{t('T10013')}</dt>
                    <dd className="define_detail">{t('T20158')}</dd>
                  </div>
                  <div className="define_item">
                    <dt className="define_term">{t('T20000')}</dt>
                    <dd className="define_detail">{t('T20159')}</dd>
                  </div>
                </dl>
              </GuideItem>
              <GuideItem title={t('T20160')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20161')}</li>
                  <li className="section_bullet_item">{t('T20162')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T20163')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20164')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T20165')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20166')}</li>
                </ul>
              </GuideItem>
              <GuideItem title={t('T20167')}>
                <ul className="section_bullet_list body_small_r">
                  <li className="section_bullet_item">{t('T20168')}</li>
                </ul>
              </GuideItem>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

function GuideItem({title, isInitOpen = false, children}: {title: string; isInitOpen?: boolean; children: ReactNode}) {
  const [isOpen, setIsOpen] = useState(isInitOpen);

  return (
    <li className="driving_accordion_item">
      <button
        type="button"
        className="driving_accordion_btn"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <span
          className="question_mark"
          aria-hidden={!isOpen}
        >
          Q
        </span>
        <span
          className="driving_accordion_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {title}
        </span>
        <span
          className="ic ic_arrow_down_16px"
          aria-hidden="true"
        ></span>
      </button>
      <div
        className="driving_accordion_content"
        style={{display: isOpen ? 'block' : 'none'}}
      >
        {children}
      </div>
    </li>
  );
}
